import type {z} from "zod";

import {UpdateMaterialBody} from "@project/sdk/engineering/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../shared/validation/required-string.schema";
import {materialFieldLabelIds} from "../../../messages/materials.messages";

const fields = UpdateMaterialBody.shape;
export const updateMaterialFormSchema = zod.object({
  code: requiredStringSchema(fields.code, materialFieldLabelIds.code),
  name: requiredStringSchema(fields.name, materialFieldLabelIds.name),
  internalDescription: requiredStringSchema(
    fields.internalDescription,
    materialFieldLabelIds.internalDescription,
  ),
  unitOfMeasure: fields.unitOfMeasure,
});
export type UpdateMaterialFormPayload = z.output<typeof updateMaterialFormSchema>;

export const draftUpdateMaterialFormSchema = updateMaterialFormSchema.partial();
export type DraftUpdateMaterialFormPayload = z.output<typeof draftUpdateMaterialFormSchema>;
